import React from "react";
import { Link } from "react-router-dom";

const Packages = () => {
  return (
    <div className="packages-section-wrapper">
      <div className="packages-bg-overlay">
         <img src="/PackzdfdfagedB.png" alt="Background Texture" />
      </div>

      <img src="/PackagedL.png" className="floral-bg left" alt="" />
      <img src="/PackagedR.png" className="floral-bg right" alt="" />

      <div className="container py-5 content-relative">
        <section className="app-unlock-section">
          <div className="text-center">
            <h2 className="app-unlock-title">
              Your Monthly <span className="pink-text">Pregnancy Journey</span>,<br />
              Transformed Into <span className="pink-text">Daily Celebration</span><br />
              Through Daily Handholding.
            </h2>
            <div className="app-care-point">
<i className="bi bi-heart-pulse app-care-icon" aria-hidden="true"></i><h3 className="app-unlock-subtitle">Transforming Pregnancy into Daily Care</h3>
              <p className="app-unlock-description">We elevate your pregnancy safety net up to 90% through proactive daily handholding, continuous health tracking, expert nutritional and emotional support, and 24/7 doctor access—minimizing risks and detecting complications early.</p>
            </div>
            <div className="app-care-point">
<i className="bi bi-shield-check app-care-icon" aria-hidden="true"></i><h3 className="app-unlock-subtitle">Explore Free Clinical Features</h3>
              <p className="app-unlock-description">Download the Myprega app to access our medical-grade, AI-driven pregnancy risk analyzer designed by senior doctors, and join our Mom-to-Be community of like-minded mothers in the same phase of life to share experiences and clear your doubts together.</p>
            </div>
            <div className="app-download-actions" aria-label="Download Myprega app">
              <a
                href="https://apps.apple.com/app/myprega/id6778800135"
                className="app-download-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-apple"></i>
                <span>Download on the App Store</span>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.myprega.app"
                className="app-download-btn app-download-btn-dark"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-google-play"></i>
                <span>Get it on Google Play</span>
              </a>
            </div>
          </div>

          <p className="app-preview-note">Your Complete Pregnancy Safety Net, At Your Fingertips.</p>
          <div className="app-preview-image"><img src="/myprega-safety-net.png" alt="Myprega pregnancy app preview" /></div>
        </section>

        <div className="text-center mb-5">
          <h2 className="journey-title">
            Everything Your Journey Needs, <br />
            Perfectly <span className="pink-text">Packaged.</span>
          </h2>
          <p className="journey-subtitle mx-auto">
            We’ve replaced the hidden costs and confusing hospital bills with complete
            transparency. Experience the future of pregnancy care risk-free, or dive straight into our
            all-inclusive sanctuary designed for your absolute peace of mind.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          <div className="col-lg-5 col-md-6">
            <div className="package-card hover-lift">
              <div className="card-image-box">
                <img src="/Packaged1.png" alt="Discovery" className="img-fluid" />
              </div>
              <div className="card-body-content">
                <h3 className="card-package-name">The Discovery Experience</h3>
                <div className="price-tag">
                  <span className="currency">₹</span>0 <small>(Complimentary 7-Day Access)</small>
                </div>
                <ul className="package-features-list">
                  <li><i className="bi bi-check2-circle"></i> 7-Day Platform Access</li>
                  <li><i className="bi bi-check2-circle"></i> Daily Garbhasanskar</li>
                  <li><i className="bi bi-check2-circle"></i> 24/7 Emergency Support</li>
                  <li><i className="bi bi-check2-circle"></i> End-to-End Taste</li>
                </ul>
                <Link to="/elemental-care" className="btn-package btn-solid">
                  Experience It For Free
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-md-6">
            <div className="package-card featured-card hover-lift">
              <div className="card-image-box">
                <img src="/Packaged2.png" alt="Signature Care" className="img-fluid" />
              </div>
              <div className="card-body-content">
                <h3 className="card-package-name">The Signature Care Ecosystem</h3>
                <div className="price-tag">
                  <span className="currency">₹</span>7,222 <small>/ Month</small>
                </div>
                <ul className="package-features-list">
                  <li><i className="bi bi-check2-circle"></i> A Dedicated Circle of 9 Medical Experts</li>
                  <li><i className="bi bi-check2-circle"></i> 44+ Doctor Consultations</li>
                  <li><i className="bi bi-check2-circle"></i> 9 Ultrasound Scans</li>
                  <li><i className="bi bi-check2-circle"></i> 40+ Pathology & Genetic Lab Tests </li>
                  <li><i className="bi bi-check2-circle"></i> AI-Powered Daily Health & Vitals Tracking</li>
                  <li><i className="bi bi-check2-circle"></i> 24/7 Instant Emergency Support</li>
                  <li><i className="bi bi-check2-circle"></i> Personalized Diet & Nutrition Plans</li>
                  <li><i className="bi bi-check2-circle"></i> Live Yoga & Safe Prenatal Fitness Sessions</li>
                  <li><i className="bi bi-check2-circle"></i> 1-on-1 Monthly Mental Health & Lactation Coaching</li>
                  <li><i className="bi bi-check2-circle"></i> Daily Garbhasanskar & Fetal Bonding Rituals</li>
                  <li><i className="bi bi-check2-circle"></i> Monthly Parenting Masterclasses</li>
                  <li><i className="bi bi-check2-circle"></i> Monthly Care Review Sessions</li>
                  <li><i className="bi bi-check2-circle"></i> 24*7 WhatsApp Access to Gynecologist</li>
                  <li><i className="bi bi-check2-circle"></i> Premium Pregnancy Care Kit</li>
                  <li><i className="bi bi-check2-circle"></i> Exclusive Monthly Surprise Hampers</li>
                  <li><i className="bi bi-check2-circle"></i> 100% End-to-End Digital Management</li>
                </ul>
                <Link to="/pricing" className="btn-package btn-solid">
                  Explore The Signature Plan
                </Link>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center mt-5 footer-quote">
          Because every mother deserves the right care at the right time
        </p>
      </div>
    </div>
  );
};

export default Packages;
